// A stable, anonymous id for this browser.
//
// Not a tracking profile: it's a random opaque string in localStorage, tied to
// nothing and never sent anywhere but our own API. It exists so the view and
// like counters can dedupe — without it, one reader refreshing a page ten times
// is ten views, and "popular" would measure restlessness.
//
// Browser-only by definition. Returns null on the server rather than inventing
// an id: an SSR-generated id would be different on every render and dedupe
// nothing.
const KEY = 'gz:vid'

export function visitorId(): string | null {
  if (typeof window === 'undefined') return null
  try {
    const existing = window.localStorage.getItem(KEY)
    if (existing) return existing
    // crypto.randomUUID needs a secure context; a Math.random fallback is fine
    // here because this id only ever has to be unique-ish per browser, and the
    // worst case of a collision is one miscounted view.
    const id =
      typeof crypto !== 'undefined' && 'randomUUID' in crypto
        ? crypto.randomUUID()
        : `v-${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`
    window.localStorage.setItem(KEY, id)
    return id
  } catch {
    // Private mode / storage disabled / quota. A reader who blocks storage
    // simply isn't counted — better than throwing inside a page render.
    return null
  }
}
